module.exports = __webpack_public_path__ + "media/images/icons/add-705a940e6b8b38ecc66bc1ebe94a6dc5.svg";